import { APIRoute } from '@/modules/utils'
import { UserCard } from '@/dataV3/Search/UserCard'
import { IRI } from 'emt-library'

export const Route = (path: IRI): APIRoute => ({
  method: 'POST',
  path,
})

export type Body = never

export type Response = UserCard
